export default __webpack_public_path__ + "static/N0088-35c9009ef5b3066e98535499aab29e38.png";